import { RouteFactory } from "@app/routePaths";
import { sideMenuConstant } from "@components/Header/constant";
import { NavigationA } from "@components/Header/types";
import { FeedTag } from "@pages/Keyword/utils/types";
import { TagType } from "@pages/Section/types";
import { NavigationItem } from "@typings/Navigation";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

export const GLOBAL_SECTIONS = [
  "startups-tech",
  "companies-markets",
  "singapore_economy-policy",
  "international_asean",
];

export const GLOBAL_KEYWORD = "/keywords/asia-pacific";

/** The BT Global navigation items on the left. */
const navigationItemsLeft: NavigationItem[] = [
  {
    ...sectionNavigationItems["singapore/economy-policy"],
    extraClass: cn("text-gray-550 hover:text-gray-925 123"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems["companies-markets"],
    label: "Companies",
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems.international,
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    key: "keywords/asean",
    link: RouteFactory.keywords("asean"),
    label: "Asean",
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems.singapore,
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems["opinion-features"],
    label: "Opinion",
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems["startups-tech"],
    label: "Tech",
    extraClass: cn("text-gray-550 hover:text-gray-925"),
    ref: "global-header",
  },
  {
    ...sectionNavigationItems["bt-luxe"],
    label: "BT Luxe",
    ref: "global-header",
  },
];

/** The BT Global navigation items on the right. */
const navigationItemsRight: NavigationItem[] = [
  {
    ...sectionNavigationItems.newsletter,
    extraClass: cn("text-gray-550 hover:text-gray-925"),
  },
  {
    ...sectionNavigationItems.epaper,
    label: "Epaper",
    extraClass: cn("text-gray-550 hover:text-gray-925"),
  },
];

/** The BT Global main navigation. */
export const GLOBAL_NAVIGATION: NavigationA = [
  {
    section: {
      key: "navigation-left",
      children: navigationItemsLeft.map((navItems) => {
        return {
          ...navItems,
          children:
            navItems.children?.map((navItemsChildren) => {
              return sectionNavigationItems[navItemsChildren];
            }) || [],
        };
      }),
    },
  },
  {
    section: {
      key: "navigation-right",
      label: "Section",
      children: navigationItemsRight.map((navItems) => {
        return {
          ...navItems,
          children:
            navItems.children?.map((navItemsChildren) => {
              return sectionNavigationItems[navItemsChildren];
            }) || [],
        };
      }),
    },
  },
  // Add ref, "global-hamburger-menu," to all children of sideMenuConstant for tracking
  ...sideMenuConstant.map((item) => {
    const menuItem = {
      ...item,
      section: {
        ...item.section,
        children: item.section.children.map((child) => ({
          ...child,
          ref: "global-hamburger-menu",
        })),
      },
    };

    return menuItem;
  }),
];

export const GLOBAL_COUNTRIES: FeedTag[] = [
  {
    id: "keyword-malaysia",
    name: "Malaysia",
    type: TagType.Keyword,
    urlPath: "/keywords/malaysia?ref=global-asean",
  },
  {
    id: "keyword-indonesia",
    name: "Indonesia",
    type: TagType.Keyword,
    urlPath: "/keywords/indonesia?ref=global-asean",
  },
  {
    id: "keyword-thailand",
    name: "Thailand",
    type: TagType.Keyword,
    urlPath: "/keywords/thailand?ref=global-asean",
  },
  {
    id: "keyword-vietnam",
    name: "Vietnam",
    type: TagType.Keyword,
    urlPath: "/keywords/vietnam?ref=global-asean",
  },
  {
    id: "keyword-philippines",
    name: "Philippines",
    type: TagType.Keyword,
    urlPath: "/keywords/philippines?ref=global-asean",
  },
  {
    id: "keyword-asean-business",
    name: "All countries",
    type: TagType.Keyword,
    urlPath: "/keywords/asean-business?ref=global-asean",
  },
];
